<template>
  <span class="em-body-1" :class="{'bold': bold, 'semi-bold': semiBold, 'regular': !bold && !semiBold}">
    <slot />
  </span>
</template>
<script setup>
defineProps({
  bold: {
    type: Boolean,
    default: false
  },
  semiBold: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" scoped>
  .em-body-1{
    font-size: 18px;
    letter-spacing: -0.3px;
    line-height: 32px;
  }
  .em-body-1 :deep(.v-label) {
    font-size: 18px;
    letter-spacing: -0.3px;
    line-height: 32px;
  }
</style>
